import React from 'react'
import { Route, Switch, useParams, useRouteMatch } from 'react-router-dom'
import HomeLayout1 from 'src/components/Initiative/HomeLayout1'
import ScrollView from 'src/components/utils/ScrollView'
import SessionLayout1 from 'src/components/Schedule/SessionLayout1'
import { useInitiative } from 'src/graphql/hooks'
import { InitiativeHierarchyProvider } from 'src/libraries/contexts/InitiativeHierarchy'
import Files from '../../Files'

const InitiativeScheduleSession = () => {
   const { sessionSlug } = useParams()
   const match = useRouteMatch()
   const { initiative, networkStatus } = useInitiative({ slug: sessionSlug })

   // We don't want to display our "loading" state if the initiative
   // list is being refetched
   const initialLoading = networkStatus <= 2
   if (initialLoading) {
      return null
   }

   return (
      <InitiativeHierarchyProvider initiative={initiative}>
         <ScrollView width="100%" height="100%" scroll="on">
            <SessionLayout1
               baseUrl={match.url}>
               <Switch>
                  <Route
                     exact
                     path={match.url}
                     render={() => (
                        <HomeLayout1
                           initiative={initiative}
                        />
                     )}
                  />
                  <Route path={`${match.url}/files`} component={Files} />
               </Switch>
            </SessionLayout1>
         </ScrollView>
      </InitiativeHierarchyProvider>
   )
}

export default InitiativeScheduleSession
